import {
  RADIO_DS_ICON,
  radioDsRootStyles,
} from '@/components/@IntranetLibrary/Radio/dsRadio';

// RadioV2 를 안 거치고 MUI Radio 를 직접 쓰는 사용처도 같은 라디오가 나오도록.
export default function Radio() {
  return {
    MuiRadio: {
      defaultProps: {
        icon: RADIO_DS_ICON,
        checkedIcon: RADIO_DS_ICON,
        disableRipple: true,
      },
      styleOverrides: {
        root: radioDsRootStyles,
      },
    },
  };
}
